<template>
  <div></div>
</template>

<script>
export default {
  name: 'news-promotion'
}
</script>



// WEBPACK FOOTER //
// src/views/NewsPromotion.vue